interface PageBannerProps {
  backgroundImage?: string;
  backgroundVideo?: string;
  videoOpacity?: number;
  alt?: string;
  className?: string;
  showVideo?: boolean;
}

const PageBanner: React.FC<PageBannerProps> = ({
  backgroundImage,
  backgroundVideo,
  videoOpacity = 30,
  alt = 'Background cover',
  className = '',
  showVideo = true,
}) => {
  return (
    <div className={`absolute inset-0 z-0 h-[100dvh] w-full ${className}`}>
      {backgroundImage && (
        <img src={backgroundImage} alt={alt} className='h-full w-full object-cover' />
      )}

      {showVideo && backgroundVideo && (
        <video
          className='no-controls absolute inset-0 h-full w-full object-cover'
          style={{ opacity: videoOpacity / 100 }}
          autoPlay
          loop
          muted
          playsInline
        >
          <source src={backgroundVideo} type='video/mp4' />
        </video>
      )}
    </div>
  );
};

export default PageBanner;
